<div fxLayout="row" fxLayoutAlign="space-between start">
  <div class="fact-title text-accent uppercase">{{ title | translate }}</div>
  <div class="fact-value text-right">
    <ng-content></ng-content>
  </div>
</div>